import { Dispatcher } from 'flux';

export default new Dispatcher;


// WEBPACK FOOTER //
// ./src/dispatchers/dispatcher.js